import { render, staticRenderFns } from "./resultsReport.vue?vue&type=template&id=ee2a4780&"
import script from "./resultsReport.vue?vue&type=script&lang=js&"
export * from "./resultsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports